










































































































































































































































import { Component, Prop, Vue } from "vue-property-decorator";
import moment from "moment";

import { getTimeDistance } from "@/util/util";
import { format } from "date-fns";
import axios from "axios";

const rankingListDataSource: any[] = [];
for (let i = 0; i < 7; i += 1) {
  rankingListDataSource.push({
    title: `科室 ${i} `,
    total: 323234,
  });
}

@Component({
  components: {},
})
export default class Analysis extends Vue {
  private rangePickerValue: moment.Moment[] = getTimeDistance("year");

  private rankingListData: any[] = rankingListDataSource;

  private radarData: any[] = [];
  private visitData: any[] = [];
  private offlineChartData: any[] = [];

  private salesType: string = "all";

  private activeKey: string = "Stores 0";

  private salesTypeData: any[] = [];

  private salesTypeDataOnline: any[] = [];

  private salesTypeDataOffline: any[] = [];

  private salesData: any[] = [];

  private visitData2: any[] = [];

  private searchData: any[] = [];

  private offlineData: any[] = [];

  constructor() {
    super();
  }

  private handleTabChange(name: string) {
    this.activeKey = name;
  }

  get salesPieData(): any[] {
    let data: any[] = [];
    if (this.salesType === "all") {
      data = this.salesTypeData;
    } else {
      data =
        this.salesType === "online"
          ? this.salesTypeDataOnline
          : this.salesTypeDataOffline;
    }

    return data.map((x: any) => {
      x.item = x.x;
      x.count = x.y;
      return x;
    });
  }

  get pieTotal() {
    return this.salesPieData.reduce((pre: any, now: any) => now.y + pre, 0);
  }

  get columns() {
    return [
      {
        title: this.$t(`app.analysis.table.rank`),
        dataIndex: "index",
        key: "index",
      },
      {
        title: this.$t(`app.analysis.table.search-keyword`),
        dataIndex: "keyword",
        key: "keyword",
        scopedSlots: {
          customRender: "keyword",
        },
      },
      {
        title: this.$t(`app.analysis.table.users`),
        dataIndex: "count",
        key: "count",
        sorter: (a: any, b: any) => a.count - b.count,
        class: "alignRight",
      },
      {
        title: this.$t(`app.analysis.table.weekly-range`),
        dataIndex: "range",
        key: "range",
        sorter: (a: any, b: any) => a.range - b.range,
        scopedSlots: {
          customRender: "range",
        },
        align: "right",
      },
    ];
  }

  get pieChartData() {
    return {
      columns: ["item", "count"],
      rows: [
        { item: "手术套包", count: 4544 },
        { item: "纱布", count: 3321 },
        { item: "留置针", count: 3113 },
        { item: "输液管", count: 2341 },
        { item: "胶带", count: 1231 },
        { item: "其他", count: 1231 },
      ],
    };
  }

  private isActive(type: string) {
    const value = getTimeDistance(type);
    if (!this.rangePickerValue[0] || !this.rangePickerValue[1]) {
      return "";
    }
    if (
      this.rangePickerValue[0].isSame(value[0], "day") &&
      this.rangePickerValue[1].isSame(value[1], "day")
    ) {
      return "currentDate";
    }
    return "";
  }

  private selectDate(type: string) {
    this.rangePickerValue = getTimeDistance(type);
  }

  private handleRangePickerChange(value: any) {
    this.rangePickerValue = value;
  }

  private mounted() {
    const url = "/api/fake_chart_data";
    axios.get(url).then((res: any) => {
      const data = res.data;
      this.visitData = data.visitData;
      this.visitData2 = data.visitData2;
      this.salesData = data.salesData;
      this.searchData = data.searchData;
      this.offlineData = data.offlineData;
      this.offlineChartData = data.offlineChartData;
      this.salesTypeData = data.salesTypeData;
      this.salesTypeDataOnline = data.salesTypeDataOnline;
      this.salesTypeDataOffline = data.salesTypeDataOffline;
      this.radarData = data.radarData;
    });
  }
}
